
import Vue from 'vue'
import RModal from './index.vue'
import { RButton, RInput } from '@/components/'

export default Vue.extend({
  name: 'DirectoryCreateModal',
  components: {
    RModal,
    RButton,
    RInput,
  },
  props: {
    pending: {
      type: Boolean,
    },
  },
  data() {
    return {
      name: '',
    }
  },
  methods: {
    checkAndEmit(): void {
      const { name } = this
      if (!name) return
      this.$emit('create-directory', name)
    },
  },
})
